import { render, staticRenderFns } from "./HealthCheck.vue?vue&type=template&id=486300bf&scoped=true&"
import script from "./HealthCheck.vue?vue&type=script&lang=js&"
export * from "./HealthCheck.vue?vue&type=script&lang=js&"
import style0 from "./HealthCheck.vue?vue&type=style&index=0&id=486300bf&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "486300bf",
  null
  
)

export default component.exports